/** @jsxImportSource @emotion/react */
import { BASE_API_URL } from '@app/app-constants'
import { appLink } from '@app/config/appLink'

interface UnauthorizedPageProps {
  feature?: string
  page?: string
}

export const UnauthorizedPage = ({ feature }: UnauthorizedPageProps) => {
  switch (feature) {
    case appLink.property.featureFlag:
      window.open(
        'https://resilience-explorer.com/products/property',
        '_blank',
        'noopener,noreferrer',
      )
      return null

    default:
      window.location.href = `${BASE_API_URL}/auth/logout`
      return null
  }
}
